export default {
  groupMembers(state) {
    return state.members;
  }
};
